import React, { useCallback, useEffect, useState } from 'react';
import { useGlobalState } from './GlobalState';
import axios from 'axios';
import moment from 'moment-timezone';
import { useHistory } from 'react-router';
import { getFullDate, toUTCDate } from '../../../../utils/date';
import AvailabilityCalendar, {
  emptyDatesObject,
} from '../../../availability_calendar/AvailabilityCalendar';
import { notification } from '../../../../utils/messaging';
import dayjs from 'dayjs';

export default function SelectDate({
  handleChange,
  bookingDates,
  setBookingDates,
  activeLanguage,
  ...props
}) {
  const history = useHistory();
  // Stores a list of inFlightRequests so that the calendar is not shown as finished loaded if there is still
  // a request in flight fetching fully-booked dates
  const [inFlightRequests, setInFlightRequests] = useState([]);
  const loading = inFlightRequests.length > 0;
  const startRequest = () => {
    setInFlightRequests((prev) => [...prev].concat([true]));
  };
  const endRequest = () => {
    setInFlightRequests((prev) => [...prev].slice(0, -1));
  };

  const [, setLoadingCalenderDateAvailability] = useGlobalState(
    'loadingCalenderDateAvailability'
  );
  //   const setBookingDates = props.setDate;
  //   const bookingDates = props.date;
  const [packageData] = useGlobalState('packageData');
  const [, setAvailableTime] = useGlobalState('availableTime');
  const [formattedDisabledDates, setFormattedDisabledDates] = useState([]);
  const [packageId] = useGlobalState('packageId');
  const [editBookingDetails] = useGlobalState('editBookingDetails');

  const [, setUserSelectedTicket] = useGlobalState('userSelectedTicket');
  const [, setUserSelectedSwims] = useGlobalState('userSelectedSwims');
  const [, setUserSelectedDoubleSwim] = useGlobalState(
    'userSelectedDoubleSwim'
  );
  const [lakeListInfo] = useGlobalState('lakeListInfo');
  const [userSelectedLakeId] = useGlobalState('userSelectedLakeId');
  const [userSelectedBookingType] = useGlobalState('userSelectedBookingType');
  const [, setNoOfTicket] = useGlobalState('noOfTickets');
  const [arrivalDepartureData, setArrivalDepartureData] =
    useGlobalState('customSlotData');
  const [userSelectedBookingPackage] = useGlobalState(
    'userSelectedBookingPackage'
  );

  const [limitedDates, setLimitedDates] = useState([]);

  const lake_id = props.lake_id || '';
  const data = props.data || {};

  const resetTimeSelectionState = () => {
    setUserSelectedTicket(null);
    setAvailableTime(null);
    setNoOfTicket([]);
  };

  const getAvailabilty = (data) => {
    const axios_config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    };
    setLoadingCalenderDateAvailability(true);
    axios
      .post('fishery/lake/availability', data, axios_config)
      .then((res) => {
        if (res.status === 200) {
          let res_data = res.data.result;

          // Don't show availability messages when initially loading an edited booking (only if the date has subsequently been changed)
          const requestIsEditValues =
            editBookingDetails?.booking_id &&
            dayjs(data?.start_date).isSame(
              editBookingDetails?.arrival_timestamp,
              'day'
            ) &&
            dayjs(data?.end_date).isSame(
              editBookingDetails?.departure_timestamp,
              'day'
            );

          if (res_data?.is_available) {
            setAvailableTime(res_data);
          } else if (res_data?.message && !requestIsEditValues) {
            notification.warning({
              description: res_data.message,
            });
          }
        }
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.status === 500) {
            notification.error({
              description: 'Server Response failed. Please try again later',
            });
          } else if (err.response.status === 401) {
            props.history.push('/admin/login');
          } else if (err.response.status === 400) {
            notification.error({
              description: err.response.data['detail'],
            });
          } else if (err.response.status === 422) {
            if (err.response.data['detail'] === 'Signature has expired') {
              notification.error({
                description:
                  'Login session has been expired. Please Login to continue!',
              });
            } else {
              notification.error({
                description:
                  "OOPS! Server didn't like the request. If this persists please contact support team",
              });
            }
          } else if (err.response.status === 423) {
            notification.error({
              description:
                'Sorry ! this booking slot has been booked by another user, Try different booking!',
            });
          }
        } else {
          notification.error({
            description: 'Error processing result',
          });
        }
      })
      .finally(() => {
        setLoadingCalenderDateAvailability(false);
      });
  };

  const handleDateChange = (selectedRange) => {
    if (!selectedRange?.startDate) {
      return;
    }

    const adjustedRange = { ...selectedRange };
    const start = dayjs(selectedRange.startDate);
    let end = dayjs(selectedRange.endDate || selectedRange.startDate);

    // If package data exists, force endDate to match exact duration
    if (packageData?.package_duration?.days) {
      const durationDays = packageData.package_duration.days;
      let hasOverlap = false;
      let proposeEnd = start.add(durationDays, 'day');
      const bookedDates = formattedDisabledDates.map((date) =>
        dayjs(date).format('YYYY-MM-DD')
      );

      let current = start.clone();
      while (current.isSameOrBefore(proposeEnd, 'day')) {
        console.log(current);
        if (bookedDates.includes(current.format('YYYY-MM-DD'))) {
          hasOverlap = true;
          break;
        }
        current = current.add(1, 'day');
      }

      if (hasOverlap) {
        notification.warning({
          description: 'All dates are not available for booking.',
        });

        setTimeout(() => {
          clearSelectedDates();
        }, 400);
      } else {
        end = start.add(durationDays, 'day');
      }
    }
    adjustedRange.endDate = end.toDate();

    resetTimeSelectionState();

    bookingDates[0] = adjustedRange;
    setBookingDates(bookingDates);

    handleChange('accomodation', {
      include: 'yes',
    });
  };

  useEffect(() => {
    const startDate = getFullDate(bookingDates?.[0]?.startDate);
    const endDate = getFullDate(bookingDates?.[0]?.endDate);

    if (!startDate || !endDate) {
      return;
    }

    let payload_data = {
      start_date: startDate,
      end_date: endDate,
      lake_id: userSelectedLakeId ? userSelectedLakeId : lakeListInfo?.lake_id,
      booking_id: editBookingDetails?.booking_id,
      booking_type:
        userSelectedBookingType === 'lake_exclusive'
          ? 'lake_exclusive'
          : userSelectedBookingType,
      ...(packageId && { custom_slot_id: packageId }),
    };

    if (!payload_data.booking_type) {
      return;
    }

    getAvailabilty(payload_data);
  }, [
    // Needs to be bookingDates?.[0] and bookingDates?.[1] since the bookingDates array is kept invariant so only the children will update
    bookingDates?.[0],
    bookingDates?.[1],
    lakeListInfo?.lake_id,
    setUserSelectedDoubleSwim,
    setUserSelectedSwims,
    userSelectedBookingType,
    userSelectedLakeId,
    props?.initial_swim,
  ]);

  const getBlockedBookingDates = (_date, lake_id, rooms) => {
    const axios_config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    };

    startRequest();
    let payload_data = {
      lake_id: lake_id,
      accommodation_details: rooms
        .filter((room) => room.quantity > 0)
        .map((room) => ({
          ticket_type_id: room.product_id,
          quantity: room.quantity,
          arrival_date: '',
          departure_date: '',
        })),
      date: moment(_date).format('YYYY-MM-DD'),
    };
    axios
      .post(
        'booking/lake/details',

        payload_data,
        axios_config
      )
      .then((res) => {
        if (res.status === 200) {
          const fully_booked_dates = [
            ...new Set(res.data.result?.fully_booked_dates),
          ];
          setFormattedDisabledDates(fully_booked_dates.map(toUTCDate));
          setLimitedDates(
            res.data.result?.limited_availability_dates?.map((ld) => ({
              ...ld,
              date: toUTCDate(ld.date),
            })) || []
          );
        }
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.status === 401) {
            history.push('/admin/login');
          }
        }
      })
      .finally(() => endRequest());
  };

  useEffect(() => {
    if (lake_id) {
      getBlockedBookingDates(
        moment(new Date()).format('YYYY-MM-DD'),
        lake_id,
        data?.rooms,
        editBookingDetails?.booking_id
      );
    }
  }, [lake_id, data?.rooms]);

  const handleMonthChange = (date) => {
    let _date = moment(date)?.format('YYYY-MM-DD');
    getBlockedBookingDates(
      _date,
      lake_id,
      data?.rooms,
      editBookingDetails?.booking_id
    );
  };

  const clearSelectedDates = useCallback(() => {
    if (!bookingDates?.[0]?.startDate) {
      return;
    }

    // Keeps the object reference invariant to prevent calendar re-render (weird bug with DateRangePicker)
    bookingDates[0] = { ...emptyDatesObject };
    setBookingDates(bookingDates);
    handleChange('accomodation', {
      completed: false,
    });
  }, [bookingDates, setBookingDates]);

  return (
    <>
      <div
        id='admin-booking-date-range-picker'
        className={arrivalDepartureData ? 'custom-slot-calendar' : ''}
        key={`DatesFor${userSelectedLakeId}${userSelectedBookingType}${userSelectedBookingPackage}`}
      >
        <AvailabilityCalendar
          reRenderKey={`DatesFor${lake_id}${userSelectedBookingType}${userSelectedBookingPackage}`}
          selectedRanges={bookingDates}
          activeLanguage={activeLanguage}
          selectedPackage={
            arrivalDepartureData?.[
              userSelectedBookingPackage ? userSelectedBookingPackage - 1 : 0
            ] ?? null
          }
          fullyBookedDates={formattedDisabledDates}
          limitedAvailabilityDates={limitedDates}
          showSelectedDate={false}
          loading={loading}
          onDateSelection={handleDateChange}
          onMonthChange={handleMonthChange}
          clearSelectedDates={clearSelectedDates}
        />
      </div>
    </>
  );
}
